import * as React from 'react';
import { Rule, RulesMessages } from '../utils/validator';
import TextInput from './TextInput';
import { HatType } from './Hat';

interface NumericInputProps {
  placeHolder?: string;
  inputMode?: 'decimal' | 'numeric' | 'tel';
  name: string;
  value?: string;
  id: string;
  label: string;
  required?: boolean;
  focus?: boolean;
  allowDecimal?: boolean;
  hasError: boolean;
  errors?: any;
  minValue?: number;
  maxValue?: number;
  minLength?: number;
  maxLength?: number;
  theme?: 'night' | 'day';
  validationRules?: Rule[];
  rulesMessages?: RulesMessages;
  useRulesMessagesProp?: boolean;
  onChange?: Function;
  onComplete?: Function;
  onError?: Function;
  onBlur?: Function;
  onEsc?: Function;
  onEnter?: Function;
  onLeft?: Function;
  onRight?: Function;
  onUp?: Function;
  onDown?: Function;
  onSpace?: Function;
  hat?: HatType[];
  readOnly?: boolean;
  disabled?: boolean;
  children?: any;
  toolTip?: React.ReactNode;
  autocomplete?: string;
}

export default function NumericInput(props: NumericInputProps) {
  const componentPropsRules: Rule[] = [];
  if (props.validationRules) {
    componentPropsRules.push(...props.validationRules);
  }

  if (
    props.minLength !== undefined &&
    !componentPropsRules.some(rule => rule.ruleName === 'minLength')
  ) {
    componentPropsRules.push({
      ruleName: 'minLength',
      ruleValue: props.minLength,
      message: props.rulesMessages && props.rulesMessages.minLength,
      defaultMessage: `${props.label} should have at least ${props.minLength} digits.`
    });
  }

  if (
    props.minValue !== undefined &&
    !componentPropsRules.some(rule => rule.ruleName === 'minValue')
  ) {
    componentPropsRules.push({
      ruleName: 'minValue',
      ruleValue: props.minValue,
      message: props.rulesMessages && props.rulesMessages.minValue,
      defaultMessage: `${props.label} can not be less than ${props.minValue}.`
    });
  }

  if (
    props.maxValue !== undefined &&
    !componentPropsRules.some(rule => rule.ruleName === 'maxValue')
  ) {
    componentPropsRules.push({
      ruleName: 'maxValue',
      ruleValue: props.maxValue,
      message: props.rulesMessages && props.rulesMessages.maxValue,
      defaultMessage: `The ${props.label} value can not be more than ${props.maxValue}.`
    });
  }

  return (
    <TextInput
      placeHolder={props.placeHolder}
      name={props.name}
      inputMode={props.inputMode || 'numeric'}
      value={props.value}
      id={props.id}
      label={props.label}
      required={props.required}
      focus={props.focus}
      hasError={props.hasError}
      errors={props.errors}
      minLength={props.minLength}
      maxLength={props.maxLength}
      theme={props.theme}
      autocomplete={props.autocomplete}
      onComplete={props.onComplete}
      onError={props.onError}
      onChange={props.onChange}
      onBlur={props.onBlur}
      onEsc={(inputValue: string) => {
        if (props.onEsc !== undefined) {
          props.onEsc(inputValue);
        }
      }}
      onEnter={(inputValue: string) => {
        if (props.onEnter !== undefined) {
          props.onEnter(inputValue);
        }
      }}
      onUp={(inputValue: string) => {
        if (props.onUp !== undefined) {
          props.onUp(inputValue);
        }
      }}
      onDown={(inputValue: string) => {
        if (props.onDown !== undefined) {
          props.onDown(inputValue);
        }
      }}
      onLeft={(inputValue: string) => {
        if (props.onLeft !== undefined) {
          props.onLeft(inputValue);
        }
      }}
      onRight={(inputValue: string) => {
        if (props.onRight !== undefined) {
          props.onRight(inputValue);
        }
      }}
      onSpace={(inputValue: string) => {
        if (props.onSpace !== undefined) {
          props.onSpace(inputValue);
        }
      }}
      validationRules={componentPropsRules}
      rulesMessages={
        props.useRulesMessagesProp ? props.rulesMessages : undefined
      }
      hat={props.hat}
      allowRegex={
        props.allowDecimal ? /^\$?[0-9]*\.?[0-9]?[0-9]?$/ : /^[0-9]+$/
      }
      readOnly={props.readOnly}
      disabled={props.disabled}
      toolTip={props.toolTip}
    >
      {props.children}
    </TextInput>
  );
}
